export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-accent-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl md:text-3xl text-accent-600"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              联系我们 · 投稿合作
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              欢迎剧迷朋友们通过以下方式与我们取得联系。无论是<strong>剧集推荐投稿</strong>、<strong>内容反馈建议</strong>，还是<strong>商务合作洽谈</strong>，黄瓜影院团队都会认真对待每一条信息。您的支持是我们持续优化<strong>免费电视剧</strong>观看体验的最大动力。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-4">
              <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-mail-line text-accent-500"></i>
                contact@huanggua.tv
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-wechat-line text-accent-500"></i>
                微信公众号：黄瓜影院
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}